import React, { useState } from 'react'

const ProjectContext = React.createContext()

function ProjectProvider(props) {
    //For the IdentityValidationsComponent
    const [docsIds, setDocsIds] = useState([]) // son para imagenes de ine y selfie 
    const [metadatos, setMetadatos] = useState([]) //para pintar en el form resultado de OCR 
    const [selfieMeta, setSelfieMeta] = useState([]) // resultados de meta de Facetech
    const [transId, setTransId] = useState(null) //ocr 
    const [sequences, setSequences] = useState(0) //para saber en que captura vamos 
    const [docId, setDocID] = useState(0) //I del todo el documento (Anverso, reverso y Selfie (PDF))
    const [selectedCapture, setSelectedCapture] = useState('')  //para saber en que captura vamos 
    //Cuando regresemos al ExtractionForm  en caso de falla de captura no se pierda ese nombre.
    const [NameforField, setNameForField] = useState('')

    const value = {
        //For the IdentityValidationsComponent
        setDocsIds,
        docsIds,
        setTransId,
        transId,
        setSequences,
        sequences,
        setSelectedCapture,
        selectedCapture,
        setMetadatos,
        metadatos,
        setSelfieMeta,
        selfieMeta,
        setDocID,
        docId,
        setNameForField,
        NameforField
    }


    return (
        <ProjectContext.Provider value={value} {...props} />)

}

const useProjectContext = () => {
    const context = React.useContext(ProjectContext)
    return context
}

export {
    ProjectProvider,
    useProjectContext
}